export default __webpack_public_path__ + "static/media/moon.95310ffd.jpg";